import React, { Component } from "react";
import InternshipDivisionDescription from "./InternshipDivisionDescription";

class InternshipDivision extends Component {
  state = {
    link: "",
  };

  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    return (
      <div>
        <InternshipDivisionDescription type={this.state.link} />
      </div>
    );
  }
}

export default InternshipDivision;
